import React from 'react'
import './NotFound.css'
import page from '../images/page.jpg'
const NotFound = () => {
  return (
    <>
      <img src={page} alt="image" className='img-fluid' />
    </>
  )
}

export default NotFound